const state = {
    gpsdevices: [],
    gpsdeviceId: [],
    loading: false
};

export default state;